import domContentLoaded from 'dom-content-loaded';
import $ from 'jquery';
import 'slick-carousel';


domContentLoaded(() => {
	// トップページのスライダーの設定
	const $slider = $('.js_slider');
	$slider.on('init', (event, slick) => {
		slick.$slides.eq(0).addClass('zooming');
	});
	$slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
		slick.$slides.eq(nextSlide).addClass('zooming');
	});
	$slider.on('afterChange', (event, slick, currentSlide) => {
		slick.$slides.eq(currentSlide - 1).removeClass('zooming');
	});
	$slider.slick({
		accessibility: true,
		dots: false,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 4000,
		speed: 1000,
		pauseOnHover: false,
		fade: true,
		infinite: true,
	});
	// スライダーの内容を通達する時をフォーカスしている時のみに変更
	// const $slickList = $('.slick-list');
	// $slickList.removeAttr('aria-live');
	// $slickList.on('focus', () => {
	// 	$slickList.attr('aria-live', 'polite');
	// });
	// $slickList.on('blur', () => {
	// 	$slickList.removeAttr('aria-live', 'polite');
	// });
});